import { html } from 'lit';
import analytics, { events } from '../../../../shared/analytics';

export default function rateAnswerBlock(id: number) {
  const rateAnswer = (type: 'Like' | 'Dislike') => {
    analytics.trackEvent({
      ...events.WEB_ASSISTANT_RATE_RESPONSE,
      eventLabel: type,
    });
  };

  return html`
    <div class="rate-answer">
      Was it helpful?
      <input
        @click=${() => rateAnswer('Like')}
        name="rate-answer-${id}"
        type="radio"
        value="like"
        class="rate-answer__btn rate-answer__btn_like"
        aria-label="Like the answer">
      </input>
      <input
      name="rate-answer-${id}"
        @click=${() => rateAnswer('Dislike')}
        type="radio"
        value="dislike"
        class="rate-answer__btn rate-answer__btn_dislike"
        aria-label="Dislike the answer">
      </input>
    </div>
  `;
}
